import { gql } from '@apollo/client';
import { ErrorFragment } from '../fragments';

export const MANAGE_BASIC_EVENT = gql`
  mutation ManageBasicEvent($input: [ManageBasicEventInput!]!) {
    manageBasicEvent(input: $input) {
      message
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const MANAGE_FIELD = gql`
  mutation ManageField($input: [ManageFieldInput!]!) {
    manageField(input: $input) {
      message
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const MANAGE_VERSION_ENTITY = gql`
  mutation ManageVersionEntity($input: [ManageVersionEntityInput!]!) {
    manageVersionEntity(input: $input) {
      message
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;
